export const RuntimeVersionAttribute = "data-runtime-version";
export const ElementRootAttribute = "data-alchemy-element-root";

export const MAX_CORNER_RADIUS = 9999;
